/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiChangeField.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-change-field";

export class AutogenModelEdiChangeField<RowType extends ModelRow> extends Endpoint<RowType, RowEdiChangeFieldFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiChangeField extends ModelRow<RowEdiChangeFieldFields> {
	constructor(values?: Partial<RowEdiChangeFieldFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiChangeFieldFields {
	allow_add: string;
	allow_delete: string;
	allow_update: string;
	caption: string;
	company_id: string;
	direction: string;
	field_name: string;
	id: string;
	partner_id: string;
	profile_id: string;
	send_for_add: string;
	send_for_delete: string;
	send_for_update: string;
	table_name: string;
	transaction_set: string;
	version: string;
}

